import { render, staticRenderFns } from "./PendingVerification.vue?vue&type=template&id=263b62c4&scoped=true"
import script from "./PendingVerification.vue?vue&type=script&lang=ts"
export * from "./PendingVerification.vue?vue&type=script&lang=ts"
import style0 from "./PendingVerification.vue?vue&type=style&index=0&id=263b62c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263b62c4",
  null
  
)

export default component.exports